module.exports = __webpack_public_path__ + "static/1304429993.757ecad5.jpg";